/* eslint-disable no-unused-vars */
import { axiosApiInstance } from '@/api/axios'

const urlBase = '/api/public'

const state = {
  howToBuySteps: [],
  howToBuyStepsLoading: false
}

const getters = {
  howToBuySteps: (state) => state.howToBuySteps,
  howToBuyStepsLoading: (state) => state.howToBuyStepsLoading
}

const mutations = {
  SET_HOW_TO_BUY_STEPS(state, payload) {
    state.howToBuySteps = payload
  },
  SET_HOW_TO_BUY_STEPS_LOADING(state, payload) {
    state.howToBuyStepsLoading = payload
  }
}

const actions = {
  fetchHowToBuySteps({ commit }) {
    commit('SET_HOW_TO_BUY_STEPS_LOADING', true)
    axiosApiInstance
      .get(`${urlBase}/get_how_to_buy`)
      .then((res) => {
        const data = res.data.map((el) => ({
          el: el.id,
          sort: el.sort,
          title_en: el.title_en,
          title_ru: el.title_ru,
          title_uz: el.title_uz,
          content_en: el.content_en
            .split('<p><br></p>')
            .join(`<p style='margin: 0; line-height: 0.5'><br></p>`),
          content_ru: el.content_ru
            .split('<p><br></p>')
            .join(`<p style='margin: 0; line-height: 0.5'><br></p>`),
          content_uz: el.content_uz
            .split('<p><br></p>')
            .join(`<p style='margin: 0; line-height: 0.5'><br></p>`)
        }))

        commit('SET_HOW_TO_BUY_STEPS', data)
      })
      .catch((err) => console.log(err))
      .finally(() => {
        setTimeout(() => {
          commit('SET_HOW_TO_BUY_STEPS_LOADING', false)
        }, 500)
      })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
